export default class Matomo {
    constructor() {
        try {
            // consent_1 = user don't want nothing, we stop pushing dataLayer
            if (document.cookie.includes("RGPD=consent_2") || document.cookie.includes("RGPD=consent_3")) {
                this.initTracking();
                this.trackCategoryView();
                this.ike_select_item();
                this.ike_view_date();
                this.ike_cart_add();
                this.ike_cart_remove();
                this.ike_cart_payment_success();
            }
        } catch (e) {
            // prevent blocking front on matomo error
            console.error(e);
        }
    }

    push(event, ...data) {
        let toPush = [event]
        if (data.length) {
            toPush.push(...data)
        }

        _paq.push(toPush);
        switch (event) {
            case 'setEcommerceView':
                _paq.push(['trackPageView']);
                break;
            default:
                break;
        }
    }

    initTracking() {
        var _paq = window._paq = window._paq || [];
        /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
        _paq.push(["setDocumentTitle", document.domain + "/" + document.title]);
        _paq.push(["setCookieDomain", "*.infomaniak.events"]);
        _paq.push(["setDomains", ["*.infomaniak.events"]]);
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        (function () {
            var u = "https://analytics.infomaniak.com/";
            _paq.push(['setTrackerUrl', u + 'matomo.php']);
            _paq.push(['setSiteId', '12']);
            var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
            g.async = true;
            g.src = u + 'matomo.js';
            s.parentNode.insertBefore(g, s);
        })();
    }

    /***** Category view event *****/

    trackCategoryView() {
        const genrePage = document.querySelector('.home-page.genre-page');
        if (!genrePage) {
            return;
        }

        const genre = genrePage.getAttribute('data-en-genre');
        if (!genre) {
            return;
        }

        this.push(
            'setEcommerceView',
            false,
            false,
            genre.toLowerCase()
        )
    }

    /***** Product view event *****/

    ike_view_date() {
        document.addEventListener('ike_view_date', ike_event => {
            const date = ike_event.detail.date;
            const name = date.event_languages.find(l => l.language_id === 2)?.name ?? date.languages[0].name;
            const genre = date.genres.find(g => g.language_id === 2)?.name ?? date.genres[0].name ?? 'no category';
            const averageAmount = ike_event.detail.zones.reduce((total, zone) => {
                return total + zone.tariffs.reduce((avg, tariff) => avg + tariff.float_price, 0) / (zone.tariffs.length ?? 1);
            }, 0) / (ike_event.detail.zones.length ?? 1);

            this.push(
                'setEcommerceView',
                date.id,
                name.toLowerCase(),
                genre.toLowerCase(),
                averageAmount,
            );
        });
    }

    /***** Update cart events *****/
    ike_select_item() {
        // evenement d'ajout sur la vue, mais ne fait pas réellement un ajout dans le panier, on doit donc le simuler
        document.addEventListener('ike_select_item', event => {
            // to prevent modify nested shop object, we copy it, cause they're sended by reference event in custom events
            const eventDetails = JSON.parse(JSON.stringify(event.detail));

            const cart = eventDetails.cart;
            const allSelected = eventDetails.allSelectedTariffs;
            const selection = eventDetails.selection;
            const date = eventDetails.date;

            if (!cart.tariffs) {
                cart.tariffs = {};
            }
            if (!cart.events) {
                cart.events = {};
            }

            const events = cart.events;
            const tariffs = cart.tariffs;

            if(!(date.id in events)) {
                events[date.id] = {
                    id: date.id,
                    event_languages: date.event_languages,
                    genres: date.genres ?? [],
                    ticketscount: 0,
                };
            }

            for (let tariff of allSelected) {
                const count = selection[tariff.id] ?? 0;
                if (!(tariff.id in tariffs)) {
                    tariffs[tariff.id] = {
                        event: {id: date.id},
                        amount: 0,
                        ticketscount: 0
                    }
                }
                tariffs[tariff.id].amount = (tariffs[tariff.id].ticketscount + count)*tariff.float_price;
                events[date.id].ticketscount += count;
            }
            this.addOrRemoveTariffFromCart({cart, tariffs: tariffs, events: events});
        });
    }

    ike_cart_add() {
        document.addEventListener('ike_cart_add', ike_event => {
            this.addOrRemoveTariffFromCart(ike_event.detail);
        });
    }

    ike_cart_remove() {
        document.addEventListener('ike_cart_delete', ike_event => {
            this.addOrRemoveTariffFromCart(ike_event.detail.newCart);
        });
    }

    addOrRemoveTariffFromCart(cart) {
        let allAmount = 0;

        Object.values(cart.events ?? {}).forEach(date => {
            const name = date.event_languages.find(l => l.language_id === 2)?.name ?? date.languages[0].name;
            const genre = date.genres.find(g => g.language_id === 2)?.name ?? date.genres[0].name ?? 'no category';
            const eventAmount = Object.values(cart.tariffs ?? {}).filter(t => t.event.id === date.id)
                .reduce((total, tariff) => total + Number(tariff.amount), 0);

            this.push(
                'addEcommerceItem',
                date.id,
                name.toLowerCase(),
                genre.toLowerCase(),
                date.ticketscount > 0 ? +parseFloat(eventAmount/date.ticketscount).toFixed(2) : 0, // on veut un push par date, on doit donc ramener le prix par billet a une moyenne
                date.ticketscount
            );

            allAmount += eventAmount;
        });

        this.push('trackEcommerceCartUpdate', allAmount);
    }

    /***** Purchase event *****/
    ike_cart_payment_success() {
        document.addEventListener('ike_cart_payment_success', ike_event => {
            const cart = ike_event.detail;

            const shipment = cart.shipment?.price ?? 0;
            const tva = cart.tva ?? 0;
            const tax = tva / 100 * cart.topaid;

            this.push(
                'trackEcommerceOrder',
                cart.uuid, // orderId
                cart.topaid, // Total with tax/shipping but without discounts
                cart.topaid - shipment, // Total without shipment
                tax, // Tax total
                shipment, // Total shipment
                Number(cart.topaid) !== Number(cart.topaidwithoutpromo) ? cart.topaid - cart.topaidwithoutpromo : false // discount
            );
        });
    }

}
